<template>
  <el-card class="box-card">
    <el-form ref="form" label-width="120px">
      <el-form-item label="关联卡片:" required>
        <el-tag v-if="form.vipCard" closable @close="clearCard">
          {{ form.vipCard.name }}
        </el-tag>
        <el-cascader v-else :props="cardProps" :show-all-levels="false" v-model="form.vipCardId"></el-cascader>
      </el-form-item>

      <p>自定义配置</p>

      <el-form-item label="主标题:">
        <el-input v-model.trim="form.title" maxlength="15"></el-input><span>限制15字内</span>
      </el-form-item>
      <el-form-item label="副标题:">
        <el-input v-model.trim="form.subTitle" maxlength="12"></el-input><span>限制12字内</span>
      </el-form-item>

      <el-form-item label="副标题背景色:">
        <el-input
          v-model.trim="form.subTitleBgColor"
          placeholder="左侧颜色"
          style="width: 120px"
          maxlength="6"
        ></el-input>
        -
        <el-input
          v-model.trim="form.subTitleBgColorShade"
          placeholder="右侧颜色"
          style="width: 120px"
          maxlength="6"
        ></el-input>
        <el-button type="primary" icon="el-icon-color" @click="resetSubTitleColor">重置颜色</el-button>
        <span>请输入颜色编号 如ff7a1f</span>
        <span>&nbsp;示例：</span>
        <div
          class="color-btn"
          v-show="isShowColorEg"
          :style="
            'background: linear-gradient(to right, #' +
            (form.subTitleBgColor || form.subTitleBgColorShade || 'ff7a1f') +
            ',#' +
            (form.subTitleBgColorShade || form.subTitleBgColor || 'ea4d00')
          "
        >
          {{ form.subTitle }}
        </div>
      </el-form-item>

      <el-form-item label="按钮背景色:">
        <el-input
          v-model.trim="form.buttonBgColor"
          placeholder="左侧颜色"
          maxlength="6"
          style="width: 120px"
        ></el-input>
        -
        <el-input
          v-model.trim="form.buttonBgColorShade"
          placeholder="右侧颜色"
          maxlength="6"
          style="width: 120px"
        ></el-input>
        <el-button type="primary" icon="el-icon-color" @click="resetButtonBgColor">重置颜色</el-button>
        <span>请输入颜色编号 如ff7a1f</span>
        <span>&nbsp;示例：</span>
        <div
          class="color-btn"
          v-show="isShowBtnColorEg"
          :style="
            'background: linear-gradient(to right, #' +
            (form.buttonBgColor || form.buttonBgColorShade || 'ff7a1f') +
            ',#' +
            (form.buttonBgColorShade || form.buttonBgColor || 'ea4d00')
          "
        >
          {{ form.buttonText }}
        </div>
      </el-form-item>

      <el-form-item label="按钮文案:">
        <el-input v-model.trim="form.buttonText" style="width: 200px" maxlength="10"></el-input><span>限制10字内</span>
      </el-form-item>

      <el-form-item label="头图背景" class="avatar-uploader">
        <el-upload
          style="display: inline-block"
          :action="commonUrl.uploadImg"
          :headers="commonUrl.headers"
          :data="mediaObj"
          :multiple="false"
          :on-success="uploadSuccess"
          :show-file-list="false"
          accept="image/png, image/jpeg, image/jpg"
        >
          <div style="display: inline-block" class="avatar-uploader">
            <div v-if="form.headBgPic" class="avatar trash">
              <img :src="commonUrl.imgPrefix + form.headBgPic" />
              <div class="trashdom"></div>
              <i class="el-icon-delete avatar_edit" @click.stop="deleteCover"></i>
            </div>
            <i v-else class="iconfont icon-picture-add"></i>
          </div>
        </el-upload>
        <span class="desc">建议尺寸：750*178</span>
      </el-form-item>

      <el-form-item label="会员到期时间:">
        <el-date-picker
          v-model="form.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <span>时间设置不可单独配置，至少关联自定义配置项1个</span>
      </el-form-item>

      <el-form-item style="margin-top: 40px">
        <el-button type="warning" @click="closePage()">取 消</el-button>
        <el-button type="primary" @click="saveHandle()">保 存</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script scoped>
import commonApi from '@/api/common'
import vipCardApi from '@/api/operateManage/vipCard'
import vipTypeApi from '@/api/operateManage/vipType'
import requestApi from '@/api/operateManage/vip_renew'
let id = 0
export default {
  data() {
    return {
      id: '',
      commonUrl: commonApi.commonUrl,
      mediaObj: {
        mediaJson: JSON.stringify({
          type: 0
        })
      },
      cardProps: {
        lazy: true,
        label: 'name',
        value: 'id',
        emitPath: false,
        lazyLoad: this.getVipCards
      },
      form: {
        title: '',
        subTitle: '',
        buttonText: '',
        headBgPic: '',
        time: [],
        buttonBgColor: '',
        buttonBgColorShade: '',
        subTitleBgColor: '',
        subTitleBgColorShade: '',
        vipCardId: '',
        vipCard: null
      },
      showDialog: false,
      vipTypeList: [],
      vipCardTypes: [],
      apiLock: false
    }
  },
  props: {
    PAGEKEY: {
      type: String,
      default: () => ''
    },
    PAGEBACK: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    isShowColorEg() {
      const isValidColor = (color) => {
        // 如果颜色值为空，返回 true
        if (!color) return true
        // 使用正则表达式校验是否是有效的6位十六进制颜色值
        const regex = /^[0-9a-fA-F]{6}$/
        return regex.test(color)
      }
      return isValidColor(this.form.subTitleBgColor) && isValidColor(this.form.subTitleBgColorShade)
    },
    isShowBtnColorEg() {
      const isValidColor = (color) => {
        // 如果颜色值为空，返回 true
        if (!color) return true
        // 使用正则表达式校验是否是有效的6位十六进制颜色值
        const regex = /^[0-9a-fA-F]{6}$/
        return regex.test(color)
      }
      return isValidColor(this.form.buttonBgColor) && isValidColor(this.form.buttonBgColorShade)
    }
  },
  activated() {
    if (this.id == this.$route.params.id) {
      return
    }
    this.id = this.$route.params.id
    this.getDetail()
  },
  methods: {
    getDetail() {
      if (!this.id) {
        return
      }
      requestApi
        .getDetail({
          id: this.id
        })
        .then((res) => {
          if (res.Success) {
            let form = res.Data || {}
            form.time = []
            if (form.vipStartTime) {
              form.time[0] = form.vipStartTime
              form.time[1] = form.vipEndTime
            }
            this.form = form
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    async getVipCards(node, resolve) {
      const { level } = node
      if (level === 0) {
        const res = await vipTypeApi.getList(1, 999, { name: '' })
        let vipCardTypes = res.Data.dataList || []
        vipCardTypes = vipCardTypes.map((item) => {
          return {
            id: 'parent_' + item.id,
            value: item.id,
            name: item.name
          }
        })
        resolve(vipCardTypes)
      } else if (level === 1) {
        const query = {
          name: '',
          type: 3, // 3 正价卡、2 团购卡、 1体验卡
          vipCardTypeId: node.data.value || '',
          status: 1
        }
        const res = await vipCardApi.getList(1, 999, query)
        let vipCards = res.Data.dataList || []
        vipCards = vipCards.filter((item) => item.periodDay >= 365)
        vipCards = vipCards.map((item) => {
          return {
            id: item.id,
            name: item.name,
            leaf: true
          }
        })
        resolve(vipCards)
      } else {
        resolve([])
      }
    },

    saveHandle() {
      const isValid = this.isNonEmpty(this.form)
      if (!isValid) {
        return
      }
      if (this.apiLock) {
        return
      }
      this.apiLock = true

      let data = JSON.parse(JSON.stringify(this.form))
      if (data.time && data.time.length > 0) {
        data.vipStartTime = data.time[0]
        data.vipEndTime = data.time[1]
      }
      if (!data.id) {
        delete data.id
      }

      requestApi
        .save(data)
        .then((res) => {
          if (res.Success) {
            this.$message.success('保存成功')
            this.closePage()
          } else {
            this.$message.error(res.Msg)
          }
        })
        .finally(() => {
          this.apiLock = false
        })
    },
    isNonEmpty(data) {
      const { vipCardId, time } = data
      // 校验 vipCardId 是否为空
      if (!vipCardId) {
        this.$message.error('请选择关联卡片')
        return false
      }

      // 如果 time 非空，校验其他字段中至少有一个非空
      if (time && time.length > 0) {
        let fields = JSON.parse(JSON.stringify(data))
        delete fields.vipCardId
        delete fields.time
        let isNonEmpty = Object.values(fields).some((value) => value !== '' && value != null)
        if (!isNonEmpty) {
          this.$message.error('至少关联自定义配置项1个')
          return false
        }
      }

      // 校验颜色
      if (!this.isValidHexColor(data)) {
        this.$message.error('请正确输入颜色编号')
        return false
      }
      return true
    },
    isValidHexColor(form) {
      const hexColorRegex = /^[0-9a-fA-F]{6}$/

      // 检查每个字段
      const fields = ['subTitleBgColor', 'subTitleBgColorShade', 'buttonBgColor', 'buttonBgColorShade']
      for (const field of fields) {
        const value = form[field]
        // 如果字段有值且不是有效的6位十六进制颜色值，则返回 false
        if (value && !hexColorRegex.test(value)) {
          return false
        }
      }

      // 如果所有字段都符合规则，则返回 true
      return true
    },
    resetSubTitleColor() {
      this.form.subTitleBgColor = ''
      this.form.subTitleBgColorShade = ''
    },
    resetButtonBgColor() {
      this.form.buttonBgColor = ''
      this.form.buttonBgColorShade = ''
    },
    uploadSuccess(res) {
      if (!res.data) {
        this.$message.error(res.message)
      } else {
        this.form.headBgPic = res.data.url
        this.$message.success('上传成功')
      }
    },
    deleteCover() {
      this.form.headBgPic = ''
    },
    clearCard() {
      this.form.vipCardId = ''
      this.form.vipCard = null
    },
    //取消钩子
    closePage() {
      this.$store.dispatch('tabs/removeSpecifiedTab', this.PAGEKEY)
      this.$store.dispatch('tabs/toTargetTab', this.PAGEBACK)
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.el-card {
  padding-top: 20px;
  .el-input {
    width: 400px;
  }
}
.color-btn {
  display: inline-block;
  min-width: 150px;
  height: 36px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  border-radius: 40px;
  padding: 0 10px;
  vertical-align: middle;
  background: linear-gradient(to right, #ff7a1f, #ea4d00);
}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/vip_renew/components/page.vue